import { render, staticRenderFns } from "./elepageWarn1.vue?vue&type=template&id=4a44d4cc&scoped=true&"
import script from "./elepageWarn1.vue?vue&type=script&lang=js&"
export * from "./elepageWarn1.vue?vue&type=script&lang=js&"
import style0 from "./elepageWarn1.vue?vue&type=style&index=0&id=4a44d4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44d4cc",
  null
  
)

export default component.exports